module.exports = __webpack_public_path__ + "img/logo-icon.e267066d.png";